import React from 'react'
import type { TaskInlineInputProps } from './TaskInlineInput'
import { TaskInlineInput } from './TaskInlineInput'
import { RichTextDisplay, RichTextInlineInput } from '@ztechapps/webui.input'
import { Stack } from 'react-bootstrap'
import { BusyButtonLink } from '@ztechapps/webui.button'
import type { SetOptional } from 'type-fest'

export type TaskDescriptionInlineInputProps = SetOptional<TaskInlineInputProps, 'name'>

export const TaskDescriptionInlineInput = ({ canEdit, ...props }: TaskDescriptionInlineInputProps) => {
  return (
    <div>
      <TaskInlineInput
        name="description"
        parentInputComponent={RichTextInlineInput}
        hoverToEdit={false}
        canEdit={canEdit}
        inputProps={{ height: '50vh' }}
        emptyContent={(onClick) => (
          <div>{canEdit !== false && <BusyButtonLink text="Add Task Description" onClick={onClick} icon="edit" />}</div>
        )}
        displayContent={(e, onClick) => (
          <Stack gap={2}>
            {canEdit !== false && (
              <div>
                <BusyButtonLink text="Edit" onClick={onClick} icon="edit" />
              </div>
            )}

            {/* trustedSource: task descriptions are authored by staff via this same editor, not attacker-reachable */}
            <RichTextDisplay contentHtml={e} trustedSource />
          </Stack>
        )}
        {...props}
      />
    </div>
  )
}
